import { render, staticRenderFns } from "./LoyaltyBonusAddComponent.vue?vue&type=template&id=16dcd583&scoped=true"
import script from "./LoyaltyBonusAddComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltyBonusAddComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dcd583",
  null
  
)

export default component.exports